import { cn } from "@/lib/utils";

/** A small blue "something new" dot. Decorative: the control it sits on carries the accessible wording. */
export function NewDot({ className }: { className?: string }) {
  return <span aria-hidden className={cn("pointer-events-none size-2 rounded-full bg-brand ring-2 ring-background", className)} />;
}
